import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Constants } from '../classes/constants';

export interface ApiKey {
  api_key_id: string;
  api_key_secret?: string;
  created_at: string;
  revoked_at?: string;
}

@Injectable()
export class ApiKeyService {

  constructor(private httpClient: HttpClient) {}

  list(group: number): Observable<ApiKey[]> {
    return this.httpClient.get<ApiKey[]>(`${Constants.API_KEY_URL}?group=${group}`);
  }

  create(group: number): Observable<ApiKey> {
    return this.httpClient.post<ApiKey>(`${Constants.API_KEY_URL}?group=${group}`, {});
  }

  retrieve(uuid: string): Observable<ApiKey> {
    const url = Constants.API_KEY_DETAIL_URL.replace('{uuid}', uuid);
    return this.httpClient.get<ApiKey>(url);
  }

  revoke(uuid: string, group: number): Observable<ApiKey> {
    const url = Constants.API_KEY_DETAIL_URL.replace('{uuid}', uuid);
    return this.httpClient.delete<ApiKey>(`${url}?group=${group}`);
  }
}
